// /** @jsxImportSource @emotion/react */
import tw from "twin.macro";
import styled from 'styled-components';
import { ButtonStyled } from '../../styles/common.styled';

export const MobileBtn = styled(ButtonStyled)`
  ${tw`justify-center text-center w-full`}
  --mobile-display: flex;

  ${({ $theme }) => `
    @media ${$theme?.get('tokens.breakpoints.medium').toExpression()} {
      display: none;
    }
  `}
`;
